import axios from 'axios';
import { APIResult } from '../APIResult';

export async function getMintRanksNo(): Promise<APIResult> {

    let url = `${process.env.NEXT_PUBLIC_API_URL}/ranks/getMintRanksNo`;

    try {
        let res = await axios.get(url);

        if (res.data.status === 0) {
            let data = res.data.data;

            // Prepare data so its easier and faster to work with!
            let geneScoresHash = getRanksHash(data.geneScores);
            let visualScoresHash = getRanksHash(data.visualScores);
            let powerScoresHash = getRanksHash(data.powerScores);
            let totalScoresHash = getRanksHash(data.totalScores);

            // Need this so we can get rank for users dragons!
            let obj = {
                geneScoresHash,
                visualScoresHash,
                powerScoresHash,
                totalScoresHash
            }

            return { status: 0, data: obj }
        } else {
            return { status: -1, error: { code: -5 } }
        }

    } catch (error: any) {

        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log('Error', error.response.data);
            console.log('Error', error.response.status);
            console.log('Error', error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log('Error', error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
        }
        console.log('Error', error.config);

        return { status: -1, error: { code: -5 } }
    };


}

// Will translate to right rank number!
function getRanksHash(array: string[]) {
    let hashObj: any = {};

    for (let i = 0; i < array.length; i++)
        hashObj[array[i]] = array.length - i;

    return hashObj;
}